export default __webpack_public_path__ + "static/exp3-e54f1144caeeb533a357dc31a7f29a40.jpg";